import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ComponentId } from "./enums";

export type FormInput = {
  [ComponentId.CORRECTNESS_AGREEMENT]: string;
  [ComponentId.CONTACT_AGREEMENT]: string;
};

export type FormDataInputs = FormInput;

const initialState: FormInput = {
  [ComponentId.CORRECTNESS_AGREEMENT]: "",
  [ComponentId.CONTACT_AGREEMENT]: "",
};

const summarySlice = createSlice({
  name: "@OC/property/summary",
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<FormInput>) => {
      state[ComponentId.CORRECTNESS_AGREEMENT] =
        action.payload[ComponentId.CORRECTNESS_AGREEMENT];
      state[ComponentId.CONTACT_AGREEMENT] =
        action.payload[ComponentId.CONTACT_AGREEMENT];
    },
    setOCPropertyCorrectnessAgreement: (state, action) => {
      state[ComponentId.CORRECTNESS_AGREEMENT] = action.payload;
    },
    setOCPropertyContactAgreement: (state, action) => {
      state[ComponentId.CONTACT_AGREEMENT] = action.payload;
    },
  },
});

export const {
  setData: setOCPropertySummaryFormData,
  setOCPropertyContactAgreement,
  setOCPropertyCorrectnessAgreement,
} = summarySlice.actions;

export const { reducer } = summarySlice;
